import client from './api-client';

export const getConfiguracionForm44 = async(query) => {
    try {
        const response = await client.getImplicado(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form44: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getCasoImplicado = async(query) => {
    try {
        const response = await client.getImplicado(`caso/implicado?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getParametros = async(query) => {
    try {
        const response = await client.getImplicado(`parametros?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getDatosGestionImpicado = async(query) => {
    try {
        const response = await client.getImplicado(`getion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestionImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboMonedas = async(query) => {
    try {
        const response = await client.getImplicado(`monedas?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboInstanciaProvisiones = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboInstanciasProvisiones: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getProvisionesVigentes = async(query) => {
    try {
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaProvisionesVigentes: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getCoberturaPoliza = async(query) => {
    try {
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaCoberturaPoliza: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getGrillaProvisionesImplicados = async(query) => {
    try {
        const response = await client.getImplicado(`provisiones/implicados?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaProvisionesImplicados: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getGrillaHistorialProvisionesImplicado = async(query) => {
    try {
        const response = await client.getImplicado(`provisiones/historial?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                listaHistorialProvisionesImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const verPreInforme = async(query) => {
    try {
        const response = await client.getDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const actualizarProvisiones = async(body) => {
    try {
        const response = await client.post('provisiones/visar', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaActProvisiones: response.data};
        } else {
            return {respuestaActProvisiones: response.data};
        }

    } catch(error){
        throw error;
    }
}

export const actualizarIndemnizacion = async(body) => {
    try {
        const response = await client.post('propuesta-indemnizacion/visar', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaActProvisiones: response.data};
        } else {
            return {respuestaActProvisiones: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetHistorialProvisionesMoneda = async (query) => {
    try {
        const response = await client.getImplicado(`provisiones/historial?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const serviceGetProvisionesImplicado = async (query) => {
    try {
        const response = await client.getImplicado(`provisiones/implicados?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const getComboResponsabilidadAsegurado = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboResponsabilidadAsegurado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getReservaCia = async(query) => {
    try {
        
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                reservaCia: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getAmparosCia = async(query) => {
    try {
        
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                amparosCia: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const autorizaRechazaReserva = async(body) => {
    try {
        const response = await client.post('provisiones/gestiona-reserva', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaGestionReserva: response.data};
        } else {
            return {respuestaGestionReserva: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const registraValorizacionPEC = async(body) => {
    try {
        const response = await client.post('valorizacion-pec', body);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaResgistroValPEC: response.data};
        } else {
            return {respuestaResgistroValPEC: response.data};
        }

    } catch(error){
        throw error;
    }
}
export const getComboDecisionCia = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboDecision: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}